/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "articles-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "categories-prod",
            "region": "eu-west-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "apireactdeploy",
            "endpoint": "https://nxg3w6rk83.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_content_delivery_bucket": "react-deploy-prod",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "http://react-deploy-prod.s3-website-eu-west-1.amazonaws.com"
};


export default awsmobile;
